import { Component } from 'preact';

/**
 * @property {?Function} props.openConsentModal
 */
export default class ConsentLink extends Component {

	/**
	 * @param {Event} event
	 */
	openConsentModal = (event) => {
		event.preventDefault();
		this.props.openConsentModal(this.props.consent.title, this.props.consent.detailUrl);
	};

	render({ consent, textBeforeLink, linkText, textAfterLink }) {
		return <span>{textBeforeLink}<a href="#" onClick={this.openConsentModal}>{linkText}</a>{textAfterLink}</span>;
	}
}



// WEBPACK FOOTER //
// ./components/blocks/raffleForm/ConsentLink.js